import { ClrCommonStrings } from "@clr/angular";


export const French: Partial<ClrCommonStrings> = {
    showColumns:'Choix colonnes',
    selectAll:'Tout montrer',
    pickColumns:'Filtres',
  };